import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { HdsLinkStandalone } from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import { boxPadding } from 'core/modifiers';
import GoToTerraform from 'core/components/core/dropdown/go-to-terraform';

/**
 *
 * `HcpAlertTerraformPermissionsGoToTerraform` is a control block at the end
 * of an alert for terraform permissions that points you to either a geo-specific
 * link of Terraform's app url along with a documentation link
 *
 *
 * ```
 * <Hcp::Alert::TerraformPermissions::GoToTerraform />
 * ```
 *
 * @class HcpAlertTerraformPermissionsGoToTerraform
 *
 */
export default class HcpAlertTerraformPermissionsGoToTerraform extends Component {
  <template>
    <Flex
      @alignItems="center"
      @direction="row"
      @gap="md"
      {{boxPadding "md 0 0 0"}}
      data-test-hcp-alert-terraform-permissions-go-to-terraform-controls
    >
      <GoToTerraform
        data-test-hcp-alert-terraform-permissions-go-to-terraform-dropdown
      />
      <HdsLinkStandalone
        @icon="docs-link"
        @iconPosition="leading"
        @href="https://developer.hashicorp.com/terraform/cloud-docs/users-teams-organizations/permissions"
        @size="small"
        @text={{t
          "components.hcp.alert.terraform-permissions.learn-more-about-terraform-permissions"
        }}
        data-test-hcp-alert-terraform-permissions-go-to-terraform-permissions-docs-link
      />
    </Flex>
  </template>
}
